import { Component, HostListener, input, output } from '@angular/core';

/**
 * Confirmação dentro do sistema de design, em vez do `window.confirm()` do browser — que ignora
 * o tema, não é estilizável e aparece fora da aplicação.
 */
@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="confirm-backdrop" (click)="cancel.emit()">
      <div class="confirm-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
        <div class="confirm-body">
          <span class="confirm-icon" [class.confirm-icon--danger]="danger()">
            <i class="fe" [class.fe-alert-triangle]="danger()" [class.fe-help-circle]="!danger()"></i>
          </span>
          <div>
            <h4 class="mb-1">{{ title() }}</h4>
            <!-- As mudanças de linha da mensagem contam: um texto em parágrafos chega em parágrafos. -->
            <p class="text-muted small mb-0" style="white-space: pre-line;">{{ message() }}</p>
          </div>
        </div>
        <div class="confirm-actions">
          <button type="button" class="btn btn-sm btn-white" (click)="cancel.emit()">{{ cancelLabel() }}</button>
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-danger]="danger()"
            [class.btn-primary]="!danger()"
            (click)="confirm.emit()"
          >{{ confirmLabel() }}</button>
        </div>
      </div>
    </div>
  `,
})
export class ConfirmDialog {
  readonly title = input('Confirmar');
  readonly message = input('');
  readonly confirmLabel = input('Continuar');
  readonly cancelLabel = input('Cancelar');
  readonly danger = input(false);

  readonly confirm = output<void>();
  readonly cancel = output<void>();

  /**
   * O Esc recusa a pergunta, como o clique no fundo. O preventDefault impede que o mesmo Esc feche
   * também o painel (`<dialog>`) por baixo — quando a pergunta nasce lá dentro.
   */
  @HostListener('document:keydown.escape', ['$event'])
  protected onEscape(event: Event): void {
    event.preventDefault();
    this.cancel.emit();
  }
}
